import AuthRoute, { IFormContainerProps } from './AuthRoute';
import Button from '@rezdy/components/Button';
import Field from '@rezdy/components/Form/Field';
import React from 'react';
import TextInput from '@rezdy/components/Form/FormElements/TextInput';
import TextStyle from '@rezdy/components/TextStyle';
import { REZDY_APP_LOGOUT } from '../constants/auth';
import { withTranslation } from 'react-i18next';

interface IConfirmSignInProps extends IFormContainerProps {
    challengeName?: string;
}

class ConfirmSignIn extends AuthRoute<IConfirmSignInProps> {
    renderBody = () => {
        const labelKeys: Record<string, string> = {
            EMAIL_OTP: 'emailOtpCode',
            SOFTWARE_MFA_TOKEN: 'mfaToken',
        };

        const { i18n, challengeName } = this.props;
        const labelIndex = challengeName ?? '';
        const labelKey = labelKeys[labelIndex] ?? 'mfaToken';
        return (
            <React.Fragment>
                <Field label={i18n.t(labelKey)} name="mfaCode">
                    <TextInput type="text" />
                </Field>
            </React.Fragment>
        );
    };

    renderFormFooter = () => {
        const { isLoading } = this.state;
        const { i18n, challengeName, context } = this.props;
        return (
            <React.Fragment>
                <Button type="submit" action="primary" loading={isLoading} width="100%" tight>
                    {i18n.t('primaryAction', { context })}
                </Button>
                {challengeName === 'EMAIL_OTP' && REZDY_APP_LOGOUT && (
                    <TextStyle align="center">
                        <a href={REZDY_APP_LOGOUT}>{i18n.t('tryAgainAction')}</a>
                    </TextStyle>
                )}
            </React.Fragment>
        );
    };
}

export default withTranslation()(ConfirmSignIn);
